import { CityRO } from '@routellers/types/dist/city/city.ro';

import { ApiMethodDeclaration } from '..';

/** ID city */
type ParamsData = number;

type ResponseData = CityRO;

export const refreshLocalization: ApiMethodDeclaration<ParamsData, ResponseData> = (id) => ({
    url: `/cities/${id}/refresh-localization`,
    method: 'PATCH',
});
